Auth = require 'db/auth'

module.exports =
  locales: [window.locale, 'en-GB']



// WEBPACK FOOTER //
// ./app/scripts/db/locale-information.coffee